var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(-572 -272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M646.013,292a3.048,3.048,0,0,1-1.22-.711,2.175,2.175,0,0,1-.56-1.464q-.016-2.066,0-4.131c0-.551.317-.851.788-.816a.681.681,0,0,1,.645.762c.006,1.3,0,2.606,0,3.909,0,.8.228,1.024,1.051,1.024h8.924c.739,0,.97-.227.97-.954q0-7.619,0-15.237c0-.727-.231-.954-.97-.954h-9.015c-.7,0-.957.248-.959.935,0,1.3,0,2.606,0,3.909,0,.556-.238.843-.691.853s-.739-.283-.743-.817c-.011-1.377-.02-2.754,0-4.131A2.225,2.225,0,0,1,646.013,272h10.242a2.416,2.416,0,0,1,1.813,1.778v16.444A2.416,2.416,0,0,1,656.255,292Z",
    transform: "translate(-66.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M572,340.385a15.894,15.894,0,0,1,1.348-1.406q1.09-1.107,2.2-2.2a.683.683,0,1,1,.949.963c-.6.607-1.2,1.205-1.8,1.808-.1.1-.184.2-.284.307a.807.807,0,0,0,.488.064q5.216,0,10.432,0c.722,0,1.027.193,1.04.654.013.478-.306.69-1.047.69q-5.216,0-10.432,0a.719.719,0,0,0-.494.078l1.958,1.954c.48.479.56.884.242,1.2s-.7.26-1.2-.241q-1.445-1.445-2.889-2.892c-.177-.179-.337-.375-.5-.564Z",
    transform: "translate(0 -58.597)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon11);
export default __webpack_public_path__ + "static/media/sidebar_icon11.1c27d09a4e13c9ddfd21533d7b357758.svg";
export { ForwardRef as ReactComponent };